module.exports = __webpack_public_path__ + "static/img/img(50).59f24c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(50).png
// module id = G7eu
// module chunks = 1